var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29214",
    "data-name": "Group 29214",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32763",
    "data-name": "Group 32763",
    transform: "translate(25.091 25.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35268",
    "data-name": "Path 35268",
    d: "M1409.481,718.782a18.313,18.313,0,0,0-2.258-5.445l1.952-4.363-3.9-3.9-4.332,1.949a18.929,18.929,0,0,0-5.448-2.259l-1.7-4.455h-5.538l-1.671,4.455a18.641,18.641,0,0,0-5.449,2.259l-4.36-1.949-3.9,3.9,1.946,4.363a18.62,18.62,0,0,0-2.259,5.445l-4.452,1.671v5.538l4.452,1.7a18.952,18.952,0,0,0,2.259,5.448l-1.946,4.329,3.9,3.9,4.36-1.949a18.464,18.464,0,0,0,5.449,2.259l1.671,4.458h5.538l1.7-4.458a18.746,18.746,0,0,0,5.448-2.259l4.332,1.949,3.9-3.9-1.952-4.329a18.634,18.634,0,0,0,2.258-5.448l4.455-1.7v-5.538Zm-18.44,16.707a12.267,12.267,0,1,1,12.253-12.252A12.269,12.269,0,0,1,1391.042,735.49Z",
    transform: "translate(-1368.119 -700.312)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateModalIcon);
export default __webpack_public_path__ + "static/media/create_modal_icon.f974570655a66ab115bbca15e4aa83fb.svg";
export { ForwardRef as ReactComponent };